import React, { Component } from 'react';
import { Header, Segment, Label } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';

class CompanyContactInformation extends Component {
  render() {
    const errorLabel = <Label color="red" pointing basic />;

    return (
      <Segment>
        <Header as="h2">Bedriftens kontaktinformasjon</Header>
        <Form.Group widths="equal">
          <Form.Input
            name="phone"
            label="Telefon"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Telefonnummer er påkrevd'
            }}
            errorLabel={errorLabel}
          />
          <Form.Input
            name="00Nb0000004dy05"
            label="E-post"
            required
            validations="isEmail"
            validationErrors={{
              isEmail: 'Dette er ikke en gyldig e-post adresse',
              isDefaultRequiredValue: 'E-post er påkrevd'
            }}
            errorLabel={errorLabel}
          />
        </Form.Group>
        <Form.Input
          name="URL"
          label="Nettside"
          required
          validations="isURL_custom"
          validationErrors={{
            isDefaultRequiredValue: 'Nettside er påkrevd',
            isURL_custom: 'Det er ikke en gyldig nettaddresse'
          }}
          errorLabel={errorLabel}
        />
      </Segment>
    );
  }
}

export default CompanyContactInformation;



// WEBPACK FOOTER //
// ./src/Form/CompanyContactInformation.js